module.exports = __webpack_public_path__ + "static/media/american.3c504bec.jpg";